import { CultureInfo } from '../culture-info.model';
import { CultureInfoAz } from './az';

/**
 * @ignore
 */
export const CultureInfoAzCyrl: CultureInfo = {
  name: 'az-Cyrl',
  displayName: 'Azerbaijani (Cyrillic)',
  iso3LanguageCode: 'aze',
  iso2LanguageCode: 'az',
  ietfLanguageTag: 'az-Cyrl',
  parent: CultureInfoAz
};
